import create from 'zustand'

export const useStore = create(set => ({
  donationSummary:{},
  setDonationSummary: (donation) => set(state => ({ donationSummary: donation })),
}))